import { onLoad } from 'utils/on_load'

import 'load_htmx'

import Rails from '@rails/ujs'
Rails.start()

import '@kollegorna/cocoon-vanilla-js'

import Modal from "components/modal"
onLoad(Modal.init)

import 'monkey_patches'
import 'define_globals'

import 'components/click_me' // '[data-js-click-me]'
import 'components/dropdown' // ["#dropdown-login li", "#dropdown-login input", "#dropdown-login label"]
import 'components/instantsearch'

import "algolia_data"

import "controllers"

// Used by the local_time helper/gem, please don't remove!
import LocalTime from "local-time"
LocalTime.start()

const techDiagnosticsElement = document.getElementById("js-tech-diagnostics")
if (techDiagnosticsElement !== null) {
  techDiagnosticsElement.innerHTML = "Yes"
}
